import React from "react";
import { Box, Typography } from "@material-ui/core";
import useAssistedAffiliationStyles from "../styles";

type FormSectionProps = {
  id?: string;
  number?: number;
  title: string;
  required?: boolean;
  subtitle?: string;
  children: React.ReactNode;
};

const FormSection = ({
  id,
  number,
  title,
  required = false,
  subtitle,
  children,
}: FormSectionProps) => {
  const classes = useAssistedAffiliationStyles();

  return (
    <Box id={id} className={classes.section}>
      <Box className={classes.sectionHeader}>
        {number ? <Box className={classes.sectionNumber}>{number}</Box> : null}
        <Box>
          <Typography variant="h6">
            {title}
            {required ? <span className={classes.requiredMark}> *</span> : null}
          </Typography>
          {subtitle ? (
            <Typography variant="caption" color="textSecondary">
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      </Box>
      <Box className={classes.sectionContent}>{children}</Box>
    </Box>
  );
};

export default FormSection;
